import React, { useEffect, useState } from 'react';
import { Radio } from 'antd';
import cl from 'classnames';
import { connect, history } from 'umi';
import { get } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Text } from '@digitalc/dxp-ui';
import useGCPI18n from '@/hooks/useGCPI18n';
import { BaseSpin } from '@/components';
import DataOffers from '../../../components/DataOffers';
import { HexToRGB, getThemeImgByKey } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import styles from './index.less';
// import noDataImg from '@/assets/images/point/point_no_Data.png';
import noDataImgGlobe from '@/assets/images/point/point_no_Data_globe.png';

const DEFAULT_PAGE_SIZE = 10;
function TabCategory({
  visible,
  moreLink,
  topMargin,
  highlightColor,
  highlightColorOpacity,
  dispatch,
  loading,
  isMulPoints,
  dxpToken,
  pointAccountsInfo,
  isWeb,
}) {
  const [catalog, setCatalog] = useState([]);
  const [catgctId, setcatgctId] = useState(-1);
  const [currPointsList, setCurrpointsList] = useState([]);
  const [pageInfo, setPageInfo] = useState({});
  const GCPI18n = useGCPI18n();
  const currentCatgName = catalog.find(item => item.id === catgctId)?.name || '';

  const queryCatg = () => {
    dispatch({
      type: 'pointShop/getCatgctListDXP',
      payload: null,
    }).then(catgctListres => {
      if (get(catgctListres, 'code') === '200' && get(catgctListres, 'data.prodCatgList')) {
        const prodCatgList = get(catgctListres, 'data.prodCatgList') || [];
        setCatalog(prodCatgList);
        setcatgctId(prodCatgList?.[0]?.id || -1);
        const searchPayload = {
          catgCodeList: [prodCatgList?.[0]?.id],
          pageSize: DEFAULT_PAGE_SIZE,
          pageIndex: 1,
        };
        trackSensors('reward_listing', {
          category: prodCatgList.map(item => item.name).join(','),
          action: 'screen_view',
          section: 'rewards',
        });

        dispatch({
          type: 'pointShop/getProductSearchDXP',
          payload: searchPayload,
        }).then(res => {
          if (get(res, 'pointProductList')) {
            setCurrpointsList(get(res, 'pointProductList'));
            setPageInfo(get(res, 'pageInfo'));
          } else {
            setCurrpointsList([]);
            setPageInfo({});
          }
        });
      }
    });
  };

  const selectCatgct = async e => {
    if (e.target.value === -1) {
      history.push(moreLink);
    } else {
      setcatgctId(e.target.value);
      const payload = {
        catgCodeList: [e.target.value],
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: 1,
      };
      dispatch({
        type: 'pointShop/getProductSearchDXP',
        payload,
      }).then(res => {
        if (get(res, 'pointProductList')) {
          setCurrpointsList(get(res, 'pointProductList'));
          setPageInfo(get(res, 'pageInfo'));
        } else {
          setCurrpointsList([]);
          setPageInfo({});
        }
      });
    }
  };

  useEffect(() => {
    queryCatg();
  }, []);

  // const wordStyle = {
  //   color: HexToRGB(highlightColor, highlightColorOpacity),
  // };

  // const wordLineStyle = {
  //   background: HexToRGB(highlightColor, highlightColorOpacity),
  // };

  const loadMoreData = () => {
    const payload = {
      catgCodeList: [catgctId],
      pageSize: DEFAULT_PAGE_SIZE,
      pageIndex: pageInfo.pageIndex + 1,
    };
    dispatch({
      type: 'pointShop/getProductSearchDXP',
      payload,
    }).then(res => {
      if (get(res, 'pointProductList')) {
        const newList = [...currPointsList, ...(get(res, 'pointProductList') || [])];
        setCurrpointsList(newList);
        setPageInfo(get(res, 'pageInfo'));
      } else {
        setCurrpointsList([]);
        setPageInfo({});
      }
    });
  };

  return (
    <div
      className={cl(styles.carouselBox, {
        hidden: !visible,
      })}
      style={{ marginTop: `${Number(topMargin) / 100}rem` }}
    >
      <div className={styles.inner} />
      <div className={styles.catalogBox}>
        {catalog && catalog.length > 0 && (
          <Radio.Group buttonStyle="solid" onChange={selectCatgct} value={catgctId}>
            {catalog.map(catgctItem => (
              <Radio.Button
                value={catgctItem.id}
                key={catgctItem.code}
                // style={catgctId === catgctItem?.id ? wordStyle : {}}
                style={{
                  fontFamily: dxpToken.fontFamilySecondaryBold,
                  fontWeight: catgctId === catgctItem?.id ? 700 : 400,
                  color:
                    catgctId === catgctItem?.id
                      ? HexToRGB(highlightColor, highlightColorOpacity)
                      : dxpToken.colorTextSubtle,
                  fontSize: `${dxpToken.fontSizeMobileContentC14 / 100}rem`,
                }}
              >
                {catgctItem.name}
                {/* {catgctId === catgctItem?.id && <div className={styles.btnLine} style={wordLineStyle} />} */}
              </Radio.Button>
            ))}
          </Radio.Group>
        )}
        <div
          className={cl(
            styles.pointsListBox,
            catalog && catalog?.length > 0 && styles.borderDisplay,
          )}
        >
          <BaseSpin spinning={loading}>
            <InfiniteScroll
              dataLength={currPointsList.length}
              next={loadMoreData}
              hasMore={get(pageInfo, 'hasNextPage')}
              scrollableTarget="baseLayoutWrap"
            />
            {currPointsList.length > 0 ? (
              <DataOffers
                dxpToken={dxpToken}
                isWeb={isWeb}
                isMulPoints={isMulPoints}
                pointAccountsInfo={pointAccountsInfo}
                dataOfferList={currPointsList}
                catgctList={catalog}
                catgctName={currentCatgName}
                entrancePage="DITO Offer"
              />
            ) : (
              <div className={styles.searchEmpty}>
                <img src={getThemeImgByKey('genericEmpty') || noDataImgGlobe} alt="" />
                <Text
                  style={{ marginBottom: '0.08rem', color: dxpToken.colorTextNeutral }}
                  breakpoint="Mobile"
                  size="TitleT23Bold"
                >
                  {GCPI18n({ id: 'lb_point_offer_no_data' })}
                </Text>
                <Text
                  style={{ color: dxpToken.colorTextNeutral }}
                  breakpoint="Mobile"
                  size="ContentC14Regular"
                >
                  {GCPI18n({ id: 'lb_point_offer_no_data_message' })}
                </Text>
              </div>
            )}
          </BaseSpin>
        </div>
      </div>
    </div>
  );
}

export default connect(({ pointShop, index, loading }) => ({
  ...pointShop,
  dxpToken: index.dxpToken,
  isWeb: index.isWeb,
  isMulPoints: index.isMulPoints,
  loading: loading.effects['pointShop/getProductSearchDXP'] || false,
}))(TabCategory);
